import { useTranslation } from "react-i18next";
import { HeartPulse, UserRound, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LeadDialog } from "@/components/LeadDialog";

/**
 * Primary + Secondary CTA pair used across the site.
 * layout: "row" (default) | "stack"
 */
export const CTAButtons = ({ layout = "row", size = "default", className = "", presetService = "", medicalLabel, nursingLabel }) => {
  const { t } = useTranslation();
  const medLabel = medicalLabel || t("cta.getMedical");
  const nurLabel = nursingLabel || t("cta.requestNursing");
  const stack = layout === "stack";
  const pad = size === "lg" ? "py-6 text-base" : "py-5";
  return (
    <div className={`flex ${stack ? "flex-col" : "flex-col sm:flex-row"} gap-3 ${className}`}>
      <LeadDialog
        title="Get Medical Support"
        defaultType="medical"
        presetService={presetService}
        source="cta-primary"
        trigger={
          <Button data-testid="cta-medical-btn" className={`group bg-brand ${pad} font-bold text-white hover:opacity-90`}>
            <HeartPulse className="mr-2 h-5 w-5" />
            {medLabel}
            <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Button>
        }
      />
      <LeadDialog
        title="Request Nursing Support"
        description="Tell us about the nursing or home-care support you need."
        defaultType="nursing"
        source="cta-secondary"
        trigger={
          <Button data-testid="cta-nursing-btn" variant="outline"
            className={`${pad} border-2 border-[hsl(var(--vc-line))] font-bold text-[hsl(var(--vc-ink))] hover:border-brand hover:bg-mint hover:text-brand`}>
            <UserRound className="mr-2 h-5 w-5" />
            {nurLabel}
          </Button>
        }
      />
    </div>
  );
};

export default CTAButtons;
